import React from 'react';
import PropTypes from 'prop-types';

// Card branco com borda cinza leve, para agrupar informações relacionadas em uma página
// (ex.: resumo de status, dados de pagamento). Uso: <Panel title="Resumo"><FieldRow .../></Panel>
const Panel = ({ title, actions, children, style }) => (
  <div
    style={{
      background: '#ffffff',
      border: '1px solid rgb(242, 242, 242)',
      borderRadius: 12,
      padding: 20,
      ...style,
    }}
  >
    {(title || actions) && (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 12,
        }}
      >
        {title && (
          <span style={{ fontSize: '1em', fontWeight: 600, color: '#1a1a1a' }}>
            {title}
          </span>
        )}
        {actions}
      </div>
    )}
    {children}
  </div>
);

Panel.propTypes = {
  title: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node,
  style: PropTypes.object,
};

export default Panel;
